import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Badge, CTA, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { CategoryCard } from '../../../../app/pages/CourseList/style';

export const ModalCategoriesId = 'ModalCategories';

const ModalCategories = ({ mediaIsPhone, modalClose, categories, onClick }) => {
  const scrollableAreaRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState();

  return (
    <Modal
      title="Area tematica"
      modalId={ModalCategoriesId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea ref={scrollableAreaRef}>
        <Text type="b3" mb={16}>
          Seleziona l’area tematica:
        </Text>
        {(categories || []).map((c) => {
          if (
            !c.documentsByCategory &&
            !c.coursesByCategory &&
            !c.scormsByCategory
          ) {
            return null;
          }
          return (
            <CategoryCard
              key={`category-${c?.id}`}
              onClick={() => {
                if (selectedCategory?.id === c?.id) setSelectedCategory();
                else setSelectedCategory(c);
              }}
              className={selectedCategory?.id === c?.id ? 'active' : ''}
            >
              <Text type="b3" className="label">
                {c.label}
              </Text>
              {(c?.documentsByCategory ||
                c?.coursesByCategory ||
                c?.scormsByCategory) && (
                <Badge
                  type="counter"
                  active={selectedCategory?.id === c?.id}
                  notification={
                    c?.hasNewDocuments || c?.hasNewCourses || c?.hasNewScorms
                  }
                >
                  {c?.documentsByCategory ||
                    c?.coursesByCategory ||
                    c?.scormsByCategory}
                </Badge>
              )}
            </CategoryCard>
          );
        })}
      </ScrollableArea>
      <Footer>
        <CTA
          type="primary"
          btnText="applica"
          fullsize={mediaIsPhone}
          onClick={() => {
            onClick(selectedCategory);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalCategories.propTypes = {
  onClick: PropTypes.func,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  categories: PropTypes.array,

  // dispatch
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { categories } = state.app.modal.payload;
      return { categories };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
    })
  ),
  withMediaQueries
)(ModalCategories);
